import { render, staticRenderFns } from "./KanbanOrder.vue?vue&type=template&id=6115b0fe&scoped=true"
import script from "./KanbanOrder.vue?vue&type=script&lang=js"
export * from "./KanbanOrder.vue?vue&type=script&lang=js"
import style0 from "./KanbanOrder.vue?vue&type=style&index=0&id=6115b0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6115b0fe",
  null
  
)

export default component.exports